'use strict';

class PartialPageConfiguration {
    /**
     * 時系列コレクションを最新部分・途中部分という形で切り出して扱うための Collection クラス
     *
     * 具体的に取り扱うコレクションクラスごとの振る舞いを定義する
     */
    constructor() {
    }

    /**
     * Model を時間軸の数直線上に射影するための関数。
     *
     * 多くの場合は、モデルの日時情報を unix timestamp に変換したものを利用する。
     *
     * @param model {Backbone.Model}
     * @return {Number}
     */
    modelToNumber(model) { // eslint-disable-line no-unused-vars
        throw new Error('Not Implemented.');
    }

    /**
     * EmptyPartialPageを作成する際の、開始点(現在点)に相当する値を生成する。
     * （多くの場合は、現在時刻の unix timestamp に変換したもの）
     *
     * @return {Number}
     */
    currentNowNumber() {
        throw new Error('Not Implemented.');
    }
}

module.exports = PartialPageConfiguration;



// WEBPACK FOOTER //
// ./framework/domain/partial-page/partial-page-configuration.js